import React from 'react';
import { makeStyles } from 'utils/makeStylesAdapter';
import { STEPS_INQUIRY } from 'constants/inquirys/stepsInquiry';
import {
  Box,
  Typography,
  Grid,
  Tooltip,
  TableContainer,
  Paper,
  Table,
  TableHead,
  TableRow,
  TableCell,
  TableBody,
  IconButton,
} from '@mui/material';
import DeleteIcon from '@mui/icons-material/Delete';
import { formatDateToBrazilian } from 'utils/date-time.utils';
import { changeNameStep } from 'utils/changeNameStep';
import { useSelector } from 'react-redux';

const useStyles = makeStyles(theme => ({
  root: {
    width: '100%',
    backgroundColor: 'transparent',
    padding: theme.spacing(1.5),
  },
}));

const TableFiles = props => {
  const {
    step,
    files,
    fileType,
    handleClick,
    openModalDelete,
    handleOpenRecording,
    handleSuperCertificateClick,
    viewDeleteAudienceButton,
    enableDeleteAudienceButton,
    onlyView,
  } = props;

  const customerConfig = useSelector(state => state.customerConfig);

  const classes = useStyles();

  const handleClickDelete = (fileId, event) => {
    openModalDelete(fileId, event, fileType);
  };

  const handleClickFile = (event, file) => {
    switch (fileType) {
      case 'agreementFiles':
        handleClick(event, file);
        break;
      case 'generalFiles':
        handleClick(event, file);
        break;
      case 'hearingFiles':
        handleOpenRecording(file);
        break;
      case 'agreementComplianceFiles':
        handleClick(event, file);
        break;
      case 'superCertificateFiles':
        handleSuperCertificateClick();
        break;
      case 'tasksFiles':
        handleClick(event, file);
        break;
      case 'requisitionFiles':
        handleClick(event, file);
        break;
      case 'investigatedCertificatedFiles':
        handleClick(event, file);
        break;
      default:
        break;
    }
  };

  return (
    <Box className={classes.root}>
      <Grid
        style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}
        size={{ xs: 12, sm: 12, md: 12, lg: 12, xl: 12 }}>
        <Box flex={3} width="100%">
          {files.length > 0 && (
            <TableContainer component={Paper} className={classes.container}>
              <Table className={classes.table} size="small" aria-label="a dense table" stickyHeader>
                <TableHead>
                  <TableRow>
                    {fileType === 'investigatedCertificatedFiles' ? (
                      <TableCell align="center">Tipo</TableCell>
                    ) : (
                      <>
                        <TableCell align="center">Fase</TableCell>
                        <TableCell align="center">Descrição</TableCell>
                      </>
                    )}
                    <TableCell align="center">Nome do Arquivo</TableCell>
                    <TableCell align="center">
                      {fileType === 'hearingFiles' ? 'Data Realizada' : 'Data'}
                    </TableCell>
                    {fileType === 'hearingFiles' && (
                      <TableCell align="center">Data Agendada</TableCell>
                    )}
                    {((fileType === 'hearingFiles' &&
                      viewDeleteAudienceButton &&
                      enableDeleteAudienceButton) ||
                      (fileType !== 'hearingFiles' &&
                        fileType !== 'superCertificateFiles' &&
                        fileType !== 'requisitionFiles' &&
                        fileType !== 'investigatedCertificatedFiles' &&
                        !onlyView)) && <TableCell align="center">Ações</TableCell>}
                  </TableRow>
                </TableHead>
                <TableBody>
                  {files.map(file => (
                    <TableRow
                      key={file.id}
                      hover
                      style={{ cursor: 'pointer' }}
                      onClick={event => handleClickFile(event, file)}
                    >
                      {fileType === 'investigatedCertificatedFiles' ? (
                        <TableCell align="center">{file?.type}</TableCell>
                      ) : (
                        <>
                          <TableCell component="th" scope="row" align="center">
                            <Typography variant="body2">
                              {file?.fileUploadStep
                                ? changeNameStep(file?.fileUploadStep, customerConfig)
                                : ''}
                            </Typography>
                          </TableCell>
                          <TableCell component="th" scope="row" align="center">
                            <Typography variant="body2">{file?.description}</Typography>
                          </TableCell>
                        </>
                      )}
                      <TableCell component="th" scope="row" align="center">
                        <Typography variant="body2">{file?.name}</Typography>
                      </TableCell>
                      <TableCell component="th" scope="row" align="center">
                        <Typography variant="body2">
                          {formatDateToBrazilian(file?.createdAt)}
                        </Typography>
                      </TableCell>
                      {fileType === 'hearingFiles' && (
                        <TableCell component="th" scope="row" align="center">
                          <Typography variant="body2">{formatDateToBrazilian(file?.hearing?.date)}</Typography>
                        </TableCell>
                      )}
                      {fileType === 'hearingFiles' && viewDeleteAudienceButton && file?.fileType?.displayOnScreen && (
                        <TableCell component="th" scope="row" align="center">
                          <Tooltip
                            arrow
                            placement="top"
                            title={
                              enableDeleteAudienceButton && step === STEPS_INQUIRY.AUDIENCIA
                                ? 'Remover arquivo'
                                : 'Permissão insuficiente para deletar'
                            }
                          >
                            <IconButton
                              onClick={event => handleClickDelete(file.id, event)}
                              disabled={
                                !(enableDeleteAudienceButton && step === STEPS_INQUIRY.AUDIENCIA)
                              }
                            >
                              <DeleteIcon fontSize="small" />
                            </IconButton>
                          </Tooltip>
                        </TableCell>
                      )}

                      {file?.fileType?.displayOnScreen &&
                        fileType !== 'superCertificateFiles' &&
                        fileType !== 'investigatedCertificatedFiles' &&
                        fileType !== 'requisitionFiles' &&
                        fileType !== 'hearingFiles' &&
                        !onlyView && (
                          <TableCell component="th" scope="row" align="center">
                            <Tooltip arrow placement="top" title="Remover arquivo">
                              <IconButton onClick={event => handleClickDelete(file.id, event)}>
                                <DeleteIcon fontSize="small" />
                              </IconButton>
                            </Tooltip>
                          </TableCell>
                        )}
                    </TableRow>
                  ))}
                </TableBody>
              </Table>
            </TableContainer>
          )}
        </Box>
      </Grid>
    </Box>
  );
};

export default TableFiles;
